import script from "./PhoneChangeModelDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneChangeModelDialog.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneChangeModelDialog.vue?vue&type=style&index=0&id=a4cccc78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4cccc78"]])

export default __exports__